import React, { useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import { Box, Button, TextField, Typography } from "@mui/material";
import PlainButton from "../../components/Button/PlainButton";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import type { FormikErrors, FormikProps } from "formik";
import { Field, Form, Formik } from "formik";
import { useValidateBVNDetails } from "../../hooks/api/fetch";
import { useFetchBVNDetails } from "../../hooks/api/post";
import { toast } from "react-toastify";
import CircleLoad from "../../components/Spinner/CircleLoad";
import { FormWrapper } from "../../components/FormWrapper/FormWrapper";
import PreRegisterInfo from "./PreRegisterInfo";
function PreRegister() {
  sessionStorage.removeItem("user");
  const navigate = useNavigate();
  const validateBVN = useValidateBVNDetails();
  const fetchBVNDetails = useFetchBVNDetails();
  const [showSpinner, setShowSpinner] = useState(false);
  type FormValues = {
    bvn: string;
    email?: string;
    otp?: string;
  };
  type OTPValidate = { bvn: string; email: string; otp: string };
  let formikRef: FormikProps<FormValues> | null = null;
  let validateRef: FormikProps<OTPValidate> | null = null;

  function openAccountWithBVN() {
    withReactContent(Swal).fire({
      title: "Enter your details?",
      html: (
        <Formik<FormValues>
          innerRef={(ref) => (formikRef = ref)}
          initialValues={{ bvn: "" }}
          validate={(values) => {
            const errors: FormikErrors<FormValues> = {};
            // if (!values.location) {
            //   errors.location = "Required";
            // }
            return errors;
          }}
          onSubmit={(payload) => {
            setShowSpinner(true);
            validateBVN.mutate(payload, {
              onSuccess: (response) => {
                withReactContent(Swal).fire({
                  title: "Enter OTP?",
                  html: (
                    <Formik<OTPValidate>
                      innerRef={(ref) => (validateRef = ref)}
                      initialValues={{
                        otp: "",
                        bvn: "",
                        email: "",
                      }}
                      //   validate={(values) => {
                      //     const errors: FormikErrors<FormValues> = {};

                      //     return errors;
                      //   }}
                      onSubmit={(values) => {
                        setShowSpinner(true);
                        fetchBVNDetails.mutate(
                          {
                            bvn: payload.bvn,
                            otp: values.otp,
                            emailAddress: response?.result?.emailAddress || "",
                          },
                          {
                            onSuccess: (response) => {
                              navigate("/register");
                              sessionStorage.setItem(
                                "user",
                                JSON.stringify(response?.result)
                              );
                            },
                            onError: (error: any) => {
                              toast.dismiss();
                              toast.error(
                                `${error?.response?.data?.errorMessages?.[0]?.message}`
                              );
                            },
                            onSettled: () => {
                              setShowSpinner(false);
                            },
                          }
                        );
                      }}
                    >
                      {({ setFieldValue }) => (
                        <Form>
                          <Box mt={1}>
                            <TextField
                              onChange={(e) =>
                                setFieldValue("otp", e.target.value)
                              }
                              fullWidth
                              name="otp"
                              placeholder="OTP"
                              label="OTP"
                            />
                          </Box>
                        </Form>
                      )}
                    </Formik>
                  ),
                  didOpen: () => {
                    Swal.getPopup()?.querySelector("input")?.focus();
                  },
                  preConfirm: async () => {
                    await validateRef?.submitForm();
                  },
                });
              },
              onError: (error: any) => {
                toast.dismiss();
                toast.error(
                  `${error?.response?.data?.errorMessages?.[0]?.message}`
                );
              },
              onSettled: () => {
                setShowSpinner(false);
              },
            });
          }}
        >
          {({ setFieldValue }) => (
            <Form>
              <Box mt={1}>
                <TextField
                  required
                  onChange={(e) => setFieldValue("bvn", e.target.value)}
                  fullWidth
                  name="bvn"
                  placeholder="BVN"
                  label="BVN"
                />
              </Box>
              <Box mt={2}>
                {/* <Typography variant="h6" align="left">
                  Date of birth:
                </Typography> */}
                <TextField
                  required
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFieldValue("dateOfBirth", e.target.value)}
                  type="date"
                  name="dob"
                  placeholder="DOB"
                  label="Date of birth"
                  // label="DOB"
                />
              </Box>
            </Form>
          )}
        </Formik>
      ),
      didOpen: () => {
        Swal.getPopup()?.querySelector("input")?.focus();
      },
      preConfirm: async () => {
        await formikRef?.submitForm();
        if (formikRef?.isValid) {
          //   Swal.fire({
          //     title: formikRef.values.location,
          //     icon: "success",
          //   });
        } else {
          Swal.showValidationMessage(JSON.stringify(formikRef?.errors));
        }
      },
    });
  }
  return (
    <MainLayout>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          //   minHeight: "90vh",
        }}
      >
        <Box
          width={"100%"}
          maxWidth={"500px"}
          p={2}
          height={"100%"}
          //   minHeight: "90vh",
        >
          <PreRegisterInfo />
        </Box>
        <Box
          width={"100%"}
          maxWidth={"500px"}
          // height={"100%"}
          p={2}
          sx={{
            minHeight: "100%",
          }}
          //   minHeight: "90vh",
        >
          <FormWrapper title="REGISTRATION METHOD" collapsible={false}>
            <Box
              sx={{
                height: "300px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="body1">
                {" "}
                Create your investment account
              </Typography>
              {/* <Box mt={2}>
              <Button
                variant="outlined"
                sx={{
                  // bgcolor: "primary.main",
                  // display: "flex",
                  justifyContent: "space-between",

                  p: 2,
                }}
                fullWidth
              >
                I have an account with FCMB
              </Button>
            </Box> */}
              <Box mt={3}>
                <Button
                  variant="outlined"
                  sx={{
                    // bgcolor: "primary.main",
                    // display: "flex",
                    justifyContent: "space-between",

                    p: 2,
                  }}
                  fullWidth
                  onClick={() => navigate("/register")}
                >
                  OPEN WITH FORM
                </Button>
              </Box>

              <Box mt={2}>
                <Button
                  variant="outlined"
                  onClick={openAccountWithBVN}
                  disabled
                  sx={{
                    // bgcolor: "primary.main",
                    // display: "flex",
                    justifyContent: "space-between",

                    p: 2,
                  }}
                  fullWidth
                >
                  Open using BVN (Coming Soon)
                </Button>
              </Box>
            </Box>
          </FormWrapper>
        </Box>

        <CircleLoad loading={showSpinner} color="#d6c0e7" size={100} />
      </Box>
    </MainLayout>
  );
}

export default PreRegister;
